import type { ISingleOrderStep } from 'widgets/AnketaWidget';

type InitialValidationStepsOptions = {
  isAuth?: boolean;
  initialOpenStepId?: string;
  isFirstValidation?: boolean;
};

export const getValidationSteps = (allSteps: ISingleOrderStep[], options: InitialValidationStepsOptions) => {
  const { isAuth, initialOpenStepId, isFirstValidation } = options;
  const allStepIds = allSteps.map((step) => step.formId);

  if (isFirstValidation && initialOpenStepId) {
    const stepIndex = allSteps.findIndex((step) => step.formId === initialOpenStepId);

    if (stepIndex === -1) {
      return allStepIds;
    }

    if (stepIndex === 0) {
      return [];
    }

    return allStepIds.slice(0, stepIndex);
  }

  if (isAuth) {
    return allStepIds;
  }

  return [];
};
